const tokens = {
  bnb: {
    symbol: 'BNB',
    projectLink: 'https://www.binance.com/',
    decimals: 18,
  },
  pxf: {
    symbol: 'PXF',
    address: {
      56: '0x6a4792d10BEe30Ff25d1d8F9aA3721d204d88134',
      97: '0x69B4d8350EB2c379fd164cb14225296B67ebC214',
      1337: '0x811e3e6a7918e826aA6D8231b13b399A2c2CC4C8',
       9999: '0x2ccfA027275DFc1F9Ffd4Af675A65df59D8112F5',
    },
    decimals: 18,
    projectLink: '',
  },
  busd: {
    symbol: 'BUSD',
    address: {
      56: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
      97: '0xeD1829f3Ee4C282FeD8811Bca1DC28645FFF1bA0',
      1337: '0x5FF651e4db84f9db985DDE650A80C2aAc2725D20',
      9999: '0xbfb8372a1Cd546d39e5e427061A65ff0Dd241C5E',
    },
    decimals: 18,
    projectLink: 'https://www.paxos.com/busd/',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      56: '0x55d398326f99059ff775485246999027b3197955',
      97: '0xC0C0c4E4A1C2997265D067a73b0592cc84db411c',
      1337: '0xFf3C459c53C6151B16d8C7B89DD3A6749369bb85',
      9999: '0x63fD4a1Ae3A6f24a4e203c98c398325244Ef8CD8',
    },
    decimals: 18,
    projectLink: 'https://tether.to/',
  },
  wbnb: {
    symbol: 'wBNB',
    address: {
      56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      97: '0xA75cCf1E551e5A70F5fBE35D0f19BF3A2d3144a7',
      1337: '0xd705d33243Df88b489287f32D9cb4Afb87441b97',
       9999: '0x9BcFCB9149d3b5Aa9D3C694Fa51f3B7318af8823',
    },
    decimals: 18,
    projectLink: 'https://pancakeswap.finance/',
  },
  pxp: {
    symbol: 'PXP',
    address: {
      56: '0x26aE4b6c3fD734EFAB7AA1A7eAF664009562399c',
      97: '',
      1337: '0xaB66D0e0DD4CC56436f4ae3755da34262b7f5c24',
       9999: '0xEBF5FFe2Ff3E185633fF44E76bb8272d07785Ee9',
    },
    decimals: 18,
    projectLink: '',
  },
}

export default tokens
